import { render, staticRenderFns } from "./TermsAndConditionView.vue?vue&type=template&id=1074e9f8"
import script from "./TermsAndConditionView.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports